<template>
  <div class="videocell" :id="file.info.id" style="background-color: #ffffff; box-shadow: 0 0 1px 5px #ffffff;">
    <div :id="`video${file.info.id}`" v-if="file.info.type === 'video'" style="position: relative; height: 160px; display: flex;" @click="playVideo" @mouseover="showPlayIcon = true" @mouseout="showPlayIcon = false">
      <video ref="video" preload="metadata" @pause="tryGoToStart" @loadstart="startLoading" @canplay="endLoading">
        <source :src="file.main.html_path+'#t=5,25'" type="video/mp4">
      </video>
      <div style="position: absolute; top: 10%; left: 10%; width: 80%; height: 80%; display: flex; justify-content: center;" v-show="showPlayIcon">
        <eva-icon fill="#FFFA" :name="playIconName" height="100%" width="100%"></eva-icon>
      </div>
    </div>
    <div v-else style="height: 160px; text-align: center;">
      <font-awesome-icon v-if="file.main.name.split('.')[1] === 'pdf'" :icon="['far','file-pdf']" style="color: #397f1f; font-size: 100px; margin-top: 20px " />
      <font-awesome-icon v-else-if="file.main.name.split('.')[1] === 'xls' || file.main.name.split('.')[1] === 'xlsx'" :icon="['far','file-excel']" style="color: #397f1f; font-size: 100px; margin-top: 20px " />
      <font-awesome-icon v-else-if="file.main.name.split('.')[1] === 'ppt' || file.main.name.split('.')[1] === 'pptx'" :icon="['far','file-powerpoint']" style="color: #397f1f; font-size: 100px; margin-top: 20px " />
      <font-awesome-icon v-else-if="file.main.name.split('.')[1] === 'doc' || file.main.name.split('.')[1] === 'docx'" :icon="['far','file-word']" style="color: #397f1f; font-size: 100px; margin-top: 20px " />
      <font-awesome-icon v-else-if="file.main.name.split('.')[1] === 'zip'" :icon="['far','file-archive']" style="color: #397f1f; font-size: 100px; margin-top: 20px " />
      <font-awesome-icon v-else :icon="['far','file-alt']" style="color: #397f1f; font-size: 100px; margin-top: 20px " />
      <div style="white-space: wrap; margin-top: 10px">{{ file.main.name }}</div>
    </div>
    <div style="margin: 1rem">
      <div class="md-title" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{file.info.name}}</div>
      <div class="subhead-text">{{file.info.creater_name}}</div>
      <div class="subhead-text">{{file.info.created_datetime}}</div>
      <div class="subhead-text">{{file.info.description}}</div>
      <div style="display: flex; justify-content: flex-end; margin-bottom: 0.3rem;">
        <!-- <router-link :to="{name: 'Video', query: {subject: file.info.directory_id, file: file.main.id}}" class="md-subhead">View Details</router-link> -->
      </div>
      <div class="videocell-btngroup">
        <div v-show="buttons.like" class="md-subhead" style="flex: 5;"><eva-icon fill="#397f1f" :name="heartName" @click="like" /> {{file.total_likes}}</div>
        <div v-show="buttons.bookmark" class="md-subhead"><eva-icon fill="#397f1f" :name="bookmarkName" style="margin-right:0.2rem; cursor: pointer" @click="bookmark" /></div>
        <div v-show="buttons.download" class="md-subhead" @click="download"><eva-icon fill="#397f1f" name="cloud-download-outline" style="cursor: pointer" /></div>
      </div>
    </div>
    <div>
      <div>
        <div>
          <md-button v-for="action in actions" :key="action.name" @click="action.fn(file)">{{action.name}}</md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.md-card {
    width: 320px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
}
.subhead-text{
  color: black;

}
.videocell{
  width: 20rem;
  margin: 1rem;
}
.videocell-btngroup{
  display: flex;
  justify-content: space-between;

  user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
}
.videocell-btngroup-right{
  display: flex;
  flex: 0;
  justify-content: space-between;
}
</style>
<script>
import { EvaIcon } from 'vue-eva-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFilePdf, faFileExcel, faFilePowerpoint, faFileWord, faFileArchive, faFileAlt } from '@fortawesome/free-regular-svg-icons'
library.add(faFilePdf)
library.add(faFileExcel)
library.add(faFilePowerpoint)
library.add(faFileWord)
library.add(faFileArchive)
library.add(faFileAlt)
export default {
  props: {
    file: Object,
    actions: Array,
    buttons: Object
  },
  data () {
    return {
      showPlayIcon: false,
      playIconName: 'play-circle-outline',
      loading: null
    }
  },
  components: {
    [EvaIcon.name]: EvaIcon
  },
  computed: {
    heartName: function () {
      return this.file.is_like ? 'heart' : 'heart-outline'
    },
    bookmarkName: function () {
      return this.file.is_bookmarked ? 'bookmark' : 'bookmark-outline'
    },
    isShow: function () {
      return this.file.show
    }
  },
  methods: {
    actionTrigger: function (event) {
      this.$parent.videoActionOnClick(event)
    },
    playVideo: function () {
      let video = this.$refs.video
      if (video.paused) {
        video.play()
        this.playIconName = 'pause-circle-outline'
      } else {
        video.pause()
        this.playIconName = 'play-circle-outline'
      }
    },
    tryGoToStart: function () {
      let video = this.$refs.video
      if (video.currentTime > 25) {
        video.currentTime = 5
      }
      this.playIconName = 'play-circle-outline'
    },
    like: async function () {
      let route = ''
      if (!this.file.is_like) {
        route = `resources/folders/${this.file.parent_id}/items/${this.file.info.id}/like`
      } else {
        route = `resources/folders/${this.file.parent_id}/items/${this.file.info.id}/unlike`
      }
      try {
        await this.$store.dispatch('request', {
          method: 'post',
          route: route
        })
        this.file.total_likes += this.file.is_like ? -1 : 1
        this.file.is_like = !this.file.is_like
      } catch (err) {
        console.error(err)
      }
    },
    bookmark: async function () {
      let route = ''
      if (!this.file.is_bookmarked) {
        route = `resources/folders/${this.file.parent_id}/items/${this.file.info.id}/bookmark`
      } else {
        route = `resources/folders/${this.file.parent_id}/items/${this.file.info.id}/unbookmark`
      }
      try {
        await this.$store.dispatch('request', {
          method: 'post',
          route: route
        })
        this.file.is_bookmarked = !this.file.is_bookmarked
      } catch (err) {
        console.error(err)
      }
    },
    download: function () {
      let a = window.document.createElement('a')
      a.setAttribute('href', this.file.main.html_path)
      a.setAttribute('download', 'download')
      a.setAttribute('target', '_blank')
      window.document.body.appendChild(a)
      a.click()
    },
    startLoading: function () {
      if (!this.file.info.type === 'video') return
      // console.log('start loading')
      if (!this.isShow) {
        return
      }
      this.loading = this.$loading({
        lock: true,
        background: 'rgba(0, 0, 0, 0.7)',
        target: `#video${this.file.info.id}`
      })
    },
    endLoading: function () {
      if (!this.file.info.type === 'video') return
      // console.log('endLoading')
      if (this.loading !== null) {
        this.loading.close()
      }
    }
  },
  mounted () {
    if (this.file.main === undefined || this.file.info === undefined) {
      console.log(this.file)
    }
    console.log(this.actions)
  }
}
</script>
